import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function NewsList() {
  const { selected } = useProvince();
  const [sp] = useSearchParams();
  const categorySlug = sp.get("kategori");
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data || [])); }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams({ limit: 40 });
    if (selected?.id) q.append("province_id", selected.id);
    if (categorySlug) q.append("category_slug", categorySlug);
    api.get(`/news?${q}`).then((r) => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, [selected?.id, categorySlug]);

  return (
    <div data-testid="news-list-page" className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-2">{categorySlug ? cats.find((c) => c.slug === categorySlug)?.name : "Tüm Haberler"}</h1>
      <div className="text-sm text-gray-500 mb-5">{selected?.name || "Tüm İller"}</div>
      <div className="flex gap-2 flex-wrap mb-6">
        <Link to="/haberler" className={`px-3 py-1.5 rounded-full text-xs font-semibold border ${!categorySlug ? "bg-[#e11d2a] text-white border-[#e11d2a]" : "border-gray-200 hover:border-[#e11d2a]"}`}>Tümü</Link>
        {cats.map((c) => (
          <Link key={c.id} to={`/haberler?kategori=${c.slug}`} className={`px-3 py-1.5 rounded-full text-xs font-semibold border ${categorySlug === c.slug ? "text-white border-transparent" : "border-gray-200 hover:border-[#e11d2a]"}`} style={categorySlug === c.slug ? { background: c.color } : {}}>{c.name}</Link>
        ))}
      </div>
      {loading ? (
        <div className="grid md:grid-cols-3 gap-4">
          {Array.from({ length: 9 }).map((_, i) => (<div key={i} className="aspect-[16/10] bg-gray-100 animate-pulse rounded-lg"></div>))}
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-5">
          {items.map((n) => (
            <Link key={n.id} to={`/haber/${n.slug}`} className="news-card bg-white border border-gray-100 rounded-lg overflow-hidden">
              <div className="aspect-[16/10] bg-gray-100">{n.cover_image && <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover" />}</div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1.5">
                  {n.category && <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: n.category.color }}>{n.category.name}</span>}
                  {n.province && <span className="text-[10px] text-gray-500">• {n.province.name}</span>}
                </div>
                <h3 className="font-bold leading-snug line-clamp-2">{n.title}</h3>
                <p className="text-sm text-gray-500 mt-1 line-clamp-2">{n.spot}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
